<template>
  <form-field-input
    :label="label"
    v-model="filterValue"
    :help-text="helpText"
    @change="handleInput"
    type="number"
  ></form-field-input>
</template>

<script>
export default {
  name: "FilterPostcode",
  props: {
    label: {
      type: String,
      default: "Postcode"
    },
    helpText: String,
    storeModule: {
      type: String,
      required: true
    },
    filterName: {
      type: String,
      required: true
    },
  },
  computed: {
    filterValue: {
      get() {
        return this.$store.state[this.storeModule].filters[this.filterName].postcode;
      },
      set(value) {
        this.$store.commit(this.storeModule + "/setOneFilter", [
          this.filterName,
          "postcode",
          value
        ]);
      }
    },
    text() {
      return (this.filterValue)
        ? `Postcode: ${this.filterValue}`
        : null
    },
  },
  created() {
    this.handleInput();
  },
  methods: {
    handleInput() {
      this.$emit("change", this.text);
    },
  }
};
</script>
